interface CommentClick {
  (data: string): void;
}

interface RenderForm {
  (): void;
}
interface UpdateContentIdMap {
  (map: ContentCommentIdMap): void;
}

export interface ContentCommentIdMap {
  [key: number]: {
    content: string;
    editorType: string;
    isActive: boolean;
    docId: number;
  };
}

export const CommentService = {
  state: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendDataFn: (_data: string): void => {},
    renderFormFn: (): void => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateContentIdMapFn: (_map: ContentCommentIdMap): void => {},
    contentIdMap: {} as ContentCommentIdMap,
    activeSelectionEl: null,
  },

  initSubscriber: (
    onCommentClickCallback: CommentClick,
    renderFormCallback: RenderForm,
    updateContentIdMapCallback: UpdateContentIdMap,
  ): void => {
    CommentService.state.sendDataFn = onCommentClickCallback;
    CommentService.state.renderFormFn = renderFormCallback;
    CommentService.state.updateContentIdMapFn = updateContentIdMapCallback;
  },
  sendData: (data) => {
    CommentService.state.sendDataFn(data);
  },
  showCommentForm: (): void => {
    CommentService.state.renderFormFn();
  },
  updateContentIdMap: (map: ContentCommentIdMap): void => {
    CommentService.state.contentIdMap = {
      ...CommentService.state.contentIdMap,
      ...map,
    };
    CommentService.state.updateContentIdMapFn(
      CommentService.state.contentIdMap,
    );
  },
  updateContentIdMapWithKeys: (
    keys: string[],
    docId: number,
    id: string,
  ): void => {
    // TODO: Optimize
    Object.keys(CommentService.state.contentIdMap).forEach((key) => {
      if (
        CommentService.state.contentIdMap[key].editorType === id &&
        CommentService.state.contentIdMap[key].docId === docId
      ) {
        CommentService.state.contentIdMap[key].isActive = false;
      }
    });
    keys.forEach((key) => {
      if (CommentService.state.contentIdMap[key]) {
        CommentService.state.contentIdMap[key].isActive = true;
      }
    });
    CommentService.state.updateContentIdMapFn(
      CommentService.state.contentIdMap,
    );
  },
};
